module.exports = __webpack_public_path__ + "static/media/icon_upload.d0c74605.svg";